import React, { useCallback, useState } from 'react';
import { AppButton, Box, Text } from '@common-fe/common-fe';

import { ROUTES } from '@/common';
import { Modal } from '@/components';
import { useHistory } from '@/modules/core/hooks';

import { IFieldLevelAccessSetup } from '../role.types';

import FieldLevelAccessSetupForm from './FieldLevelAccessSetupForm';
import { useFieldLevelAccessSetupStore } from './stores';

const FieldLevelAccessSetupAddModal = () => {
  const setState = useFieldLevelAccessSetupStore((state) => state.setState);
  const handleReset = useFieldLevelAccessSetupStore((state) => state.handleReset);
  const [visible, setVisible]  = useState(false);
  const handleToggleVisible = useCallback(() => {
    setVisible(!visible);
    handleReset();
  }, [handleReset, visible]);

  const history = useHistory();
  const handleSubmit = useCallback((data: IFieldLevelAccessSetup) => {
    setState(data); 
    history.push(ROUTES.FIELD_LEVEL_ACCESS_SETUP);
  } ,[history, setState]);
  return (
    <>
      <Modal
        testId='field-level-access-setup_add'
        visible={visible}
        onSetVisible={setVisible}
        wrapperStyle={{ zIndex: 10000 }}
      >
        <FieldLevelAccessSetupForm
          isModalMode
          onSubmit={handleSubmit}
          title={(
            <Text 
              size="2xl"
              weight={700}
              margin={{ bottom: 'l' }}
              style={{ lineHeight: '32px' }}>
              Create Field Level Access 
            </Text>
          )}

          footer={(
            <Box  margin={{top: 'l'}} direction="row" justify="end">
              <AppButton testId="create-field-level-access" width='160px' onClick={handleToggleVisible} buttonType='secondary'>
                Cancel
              </AppButton>
              <Box margin={{left: 's'}}>
                <AppButton testId="create-field-level-access_next" width='160px' type="submit" buttonType='primary'>
                  Next (1/2)
                </AppButton>
              </Box>
            </Box>
          )}
        >
        </FieldLevelAccessSetupForm>
      </Modal>
      <AppButton testId="create-field-level-access" width='150px' onClick={handleToggleVisible}>
        Create Access
      </AppButton>
    </>

  );
};

export default FieldLevelAccessSetupAddModal;